export const MAX_GRAPH_JSON_BYTES = 1_000_000;
export const MAX_GRAPH_NODES = 128;
export const MAX_GRAPH_EDGES = 512;
export const MAX_GRAPH_IDENTIFIER_LENGTH = 128;

export const MAX_REACHABLE_FRAME_NODES = 16;
export const MAX_GPU_RENDER_PASSES = MAX_REACHABLE_FRAME_NODES + 1;
export const MAX_GPU_RENDER_TARGETS = 20;

export const MAX_RENDER_DIMENSION = 2_048;
export const MAX_RENDER_PIXELS = 1_920 * 1_080;
export const MAX_RENDER_PIXEL_RATIO = 2;
export const MAX_RENDER_RESOURCE_PIXELS =
  MAX_RENDER_PIXELS * MAX_GPU_RENDER_TARGETS;
